import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../hooks/useTheme.js";

export function Header({ title, subtitle }: { title: string; subtitle?: string }) {
  const { i18n } = useTranslation();
  const { isDark, toggle: toggleTheme } = useTheme();

  function toggleLang() {
    const next = i18n.language === "de" ? "en" : "de";
    void i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
  }

  return (
    <header
      className="flex items-center justify-between px-7 py-5 shrink-0"
      style={{ borderBottom: "1px solid var(--border)", background: "var(--bg-surface)" }}
    >
      <div>
        <h1
          className="text-xl font-bold leading-tight tracking-tight"
          style={{ color: "var(--text-primary)" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs mt-1" style={{ color: "var(--text-muted)" }}>
            {subtitle}
          </p>
        )}
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={toggleTheme}
          className="flex items-center justify-center w-9 h-9 rounded-full transition-colors duration-150 hover:border-[var(--border-light)] hover:text-[var(--text-primary)]"
          style={{
            background: "var(--bg-card)",
            border: "1px solid var(--border)",
            color: "var(--text-secondary)",
          }}
          title={isDark ? "Light Mode" : "Dark Mode"}
        >
          {isDark ? <Sun size={15} /> : <Moon size={15} />}
        </button>

        <button
          type="button"
          onClick={toggleLang}
          className="px-3.5 py-2 rounded-full text-xs font-mono-data font-medium transition-colors duration-150 hover:border-[var(--border-light)] hover:text-[var(--text-primary)]"
          style={{
            background: "var(--bg-card)",
            border: "1px solid var(--border)",
            color: "var(--text-secondary)",
          }}
        >
          {i18n.language === "de" ? "DE → EN" : "EN → DE"}
        </button>
      </div>
    </header>
  );
}
